import { useEffect, useState } from 'react';
import {
  ArcTargets,
  DEFAULT_TARGETS,
  TARGET_STORAGE_KEY,
  normalizeTargetUpdate,
  parseStoredArcTargets,
  serializeArcTargets,
} from './arcMetrics';

export const useArcTargets = () => {
  const [targets, setTargets] = useState<ArcTargets>(() =>
    parseStoredArcTargets(sessionStorage.getItem(TARGET_STORAGE_KEY))
  );

  useEffect(() => {
    sessionStorage.setItem(TARGET_STORAGE_KEY, serializeArcTargets(targets));
  }, [targets]);

  const handleTargetChange = (field: keyof ArcTargets, value: number) => {
    setTargets((previous) => normalizeTargetUpdate(previous, field, value));
  };

  const resetToDefaults = () => {
    sessionStorage.removeItem(TARGET_STORAGE_KEY);
    setTargets({ ...DEFAULT_TARGETS });
  };

  return {
    targets,
    handleTargetChange,
    resetToDefaults,
  };
};
